import { WindowLocation } from "@gatsbyjs/reach-router";
import { parse } from "query-string";
import { GatsbyPageProps } from "../types/gatsby";

// These utils should be moved into common-js

export const useQueryString = (
  location?: GatsbyPageProps["location"] | WindowLocation
) => {
  return location ? parse(location.search) : {};
};

export const getQueryObject = (query?: string) => (query ? parse(query) : {});

export const getPathFromLocation = (location: GatsbyPageProps["location"]) => {
  const pathname =
    typeof location?.pathname === "string"
      ? location.pathname.split("/").pop()
      : "";
  return pathname;
};
